import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  method(payload) {
    const { action = 'create' } = payload || {}
    if (action === 'delete') return 'DELETE'
    if (action === 'update') return 'PUT'
    return 'POST'
  },

  url(payload) {
    const { action = 'create', ad, adId } = payload || {}
    const id = ad?.id || adId

    if (action === 'create') {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ADS_ADD)
    }

    if ((action === 'update' || action === 'delete') && !id) {
      console.error('saveAd: Missing ID for update/delete', payload)
    }

    const endpoint =
      action === 'update'
        ? ADMIN_ENDPOINTS.ADMIN_ADS_UPDATE
        : ADMIN_ENDPOINTS.ADMIN_ADS_DELETE

    return buildApiUrl(endpoint, {
      pathParams: { id },
    })
  },

  format(payload) {
    const { action = 'create', ad, updates } = payload || {}

    if (action === 'delete') {
      return {}
    }

    const adData = ad || updates || {}

    const couponData =
      typeof adData.coupon === 'object' && adData.coupon !== null
        ? adData.coupon
        : null

    return {
      title: adData.title,
      description: adData.description,
      imageUrl: adData.imageUrl || adData.picture || '',
      link: adData.link || adData.linkUrl || adData.url || '',
      position: adData.position || 'home',
      active:
        adData.active !== undefined
          ? adData.active
          : adData.isActive !== undefined
            ? adData.isActive
            : true,
      actionType: adData.actionType,
      metadata: {
        position: adData.position || 'home',
        order: adData.order ?? window.totalAds + 1,
        targetAudience:
          adData.targetAudience == 'all'
            ? ['restaurant', 'client']
            : adData.targetAudience,
        coupon: couponData || null,
        couponId: couponData?.id || null,
        dishId: adData.dishId || null,
        restaurantId: adData.restaurantId || null,
        internalPage: adData.internalPage || null,
        feature: adData.feature || null,
      },
      startDate: adData.startDate
        ? new Date(adData.startDate).toISOString()
        : undefined,
      endDate: adData.endDate
        ? new Date(adData.endDate).toISOString()
        : undefined,
    }
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message:
          raw?.message || "Une erreur est survenue lors de l'enregistrement",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Promotion enregistrée avec succès',
      data: raw.data || { saved: true },
    }
  },
}
